import "./zoom-gallery";

class MediaGallery extends HTMLElement {
  constructor() {
    super();

    this.activeVideos = [];

    window.loadSwiper.then(({ Swiper, Pagination }) => {
      this.Swiper = Swiper;
      this.Pagination = Pagination;

      this._initCarousel();
    });
  }

  disconnectedCallback() {}

  _initCarousel() {
    if (this.gallerySwiper) return;

    this._toggleSwiperClasses(true);

    const swiperParams = {
      modules: [this.Pagination],
      slidesPerView: "auto",
      spaceBetween: 16,
      speed: 400,
      zoom: {
        maxRatio: 3,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector("[data-navigation-mobile-next]"),
        prevEl: this.querySelector("[data-navigation-mobile-previous]"),
      },
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
      breakpoints: {
        1024: {
          spaceBetween: 1,
        },
      },
    };

    this.gallerySwiper = new this.Swiper(
      this.querySelector(`.${this._prefix}__media-container`),
      swiperParams,
    );

    const nextSlideButton = this.querySelector("[data-navigation-next]");
    const prevSlideButton = this.querySelector("[data-navigation-previous]");

    nextSlideButton.addEventListener("click", () =>
      this.gallerySwiper.slideNext(),
    );
    prevSlideButton.addEventListener("click", () =>
      this.gallerySwiper.slidePrev(),
    );

    this.gallerySwiper.on("slideChange", (e) => {
      nextSlideButton.disabled = e.activeIndex === e.slides.length - 1;
      prevSlideButton.disabled = e.activeIndex === 0;

      const visibleSlides = this.gallerySwiper.slides.filter((slide) =>
        slide.classList.contains("swiper-slide-visible"),
      );
      this._selectVideo(visibleSlides);
    });

    this.gallerySwiper.on("click", () => {
      if (this._isMobile) return;

      const zoomGallery = this._zoomMarkup.content.children[0];
      zoomGallery.dataset.preselectMediaIndex = this.gallerySwiper.activeIndex;

      const html = zoomGallery.outerHTML;
      this.dispatchEvent(
        new CustomEvent("markup-modal:open", {
          bubbles: true,
          detail: { html, target: "zoom-modal" },
        }),
      );
    });
  }

  _destroyCarousel() {
    if (!this.gallerySwiper) return;

    this.gallerySwiper.destroy(true, true);
    this.gallerySwiper = null;
    this._toggleSwiperClasses(false);
  }

  _toggleSwiperClasses(add) {
    this.querySelectorAll("[data-swiper-class]").forEach((el) => {
      el.classList.toggle(el.dataset.swiperClass, add);
    });
  }

  _selectVideo(els) {
    this.activeVideos.forEach((video) => video.pause());

    this.activeVideos = [];

    els.forEach((el) => {
      const video = el.querySelector("video");

      if (video) {
        this.activeVideos.push(video);
        video.play();
      }
    });
  }

  get _zoomMarkup() {
    return this.querySelector("[data-zoom-markup]");
  }

  get _prefix() {
    return this.dataset.classPrefix;
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 1024px)").matches;
  }
}

if (!customElements.get("media-gallery")) {
  customElements.define("media-gallery", MediaGallery);
}
